//import React, { useState } from "react"
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer"
import { useSelector } from "react-redux"
import { enum_Report_Type } from "./ReportUtility"
import RptPurchaseOrder from "./RptPurchaseOrder"


const ReportViewer = ({ props_ReportType, isDistributor }) => {

    const { orderData } = useSelector((state) => state.order)
    const { salePerData } = useSelector((state) => state.company)
    const randomPdfName = Math.random().toString(36).substring(2, 7)
    const rName = orderData[0]?.Ord_No || "";
    return (
        <div>

            {(orderData && orderData?.length > 0)
                ? (
                    <div style={{ width: "100%", height: "300px", margin: 10 }}>
                        {/* <PDFViewer width="100%" height="650">
                            <RptPurchaseOrder detail={orderData} isdistributor={isDistributor} />
                        </PDFViewer> */}
                        <PDFDownloadLink
                            document=
                            {props_ReportType == enum_Report_Type.PURCHASEORDER ? <RptPurchaseOrder detail={orderData}  isdistributor={isDistributor} /> : ""}

                            fileName={rName + ".pdf"}
                        >
                            {({ blob, url, loading, error }) =>
                                loading ? (
                                    "Loading document..."
                                ) :
                                    (props_ReportType == enum_Report_Type.PURCHASEORDER && orderData && orderData?.length > 0)
                                        ? (
                                            <div
                                                style={{
                                                    background: "rgb(83, 54, 171)",
                                                    textAlign: "center",
                                                    color: "white",
                                                    padding: "10px",
                                                    textTransform:"uppercase"
                                                }}
                                            >
                                                Download
                                            </div>
                                        ) : "Loading document..."
                            }
                        </PDFDownloadLink>
                    </div>
                ) : (
                    <div
                        style={{
                            background: "rgb(0, 72, 154)",
                            textAlign: "center",
                            color: "white",
                            padding: "10px",
                            marginBottom: "10px"
                        }}
                    >
                        Data not found

                    </div>
                )}
        </div>
    )
}
export default ReportViewer
